<script setup lang="ts">
import type { NuxtLinkProps } from 'nuxt/app'
import type { Props as BaseButtonProps } from '@/components/base/Button.vue'
import BaseButton from '@/components/base/Button.vue'

type Props = Omit<BaseButtonProps, 'to'> & {
  /**
   * Route Location the button/link should navigate to when clicked on.
   */
  to: NuxtLinkProps['to']
}

const props = defineProps<Props>()
const buttonProps = {
  ...props,
  to: props.to as BaseButtonProps['to'],
} satisfies BaseButtonProps
</script>

<template>
  <BaseButton v-bind="buttonProps">
    <slot name="start" />
    <slot />
    <slot name="end" />
  </BaseButton>
</template>
